<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors, invalid, validated }"
    :mode="validateMode"
    slim
  >
    <vvs-control-wrapper
      :label="label"
      :description="description"
      :is-required="isRequired"
      :error="errors[0]"
      :loading="loading"
      :normal-label="normalLabel"
    >
      <select
        v-model="proxy"
        @change="onSelectChanged"
        :class="{
          error: validated && invalid,
          'vvs-select-multiple': formControlOptions.multiple,
        }"
        v-bind="formControlOptions"
      >
        <option :value="null">{{ emptyText }}</option>
        <option
          v-for="(option, optionIndex) in options"
          :key="optionIndex"
          :value="option"
        >
          {{ returnObject ? option[itemText] : option }}
        </option>
      </select>
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';
export default {
  name: 'VvsSelect',
  mixins: [formControlMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: 'Lütfen bir seçim yapınız',
    },
  },
  methods: {
    onSelectChanged($event) {
      this.onInput($event);
      this.onChange($event);
    },
  },
};
</script>

<style lang="scss">
.vvs-select-multiple {
  min-height: 200px;

  option {
    text-align: left;
    padding: 10px 5px !important;
    height: inherit !important;
    font-size: 100% !important;
  }
}
</style>
